import { Button, CircularProgress, Dialog, DialogTitle, DialogActions, DialogContent, Divider, Grid, IconButton } from '@mui/material'
import React, { useEffect, useState } from 'react'
import DashboardContainer from '../../components/DashboardContainer'
import PageContainer from '../../components/PageContainer'
import { AddorUpdateRecord, getList } from '../../redux/api/system'
import { Formik, Form } from 'formik'
import { useSnackbar } from 'notistack'
import { DataGrid } from '@mui/x-data-grid'
import TextInput from '../../components/common/TextInput';
import { useHistory } from 'react-router-dom'
import SelectInput from '../../components/common/SelectInput'
import { Add, Delete, Edit, Label } from '@mui/icons-material';
import { dataTypeOptions } from '../../util'
import MultipleSelectChip from '../../components/common/MultipleSelectChip';
import DialogBox from '../../components/common/DialogBox'
import TuneIcon from '@mui/icons-material/Tune';

const CreateDataView = () => {
    const [ showModal, setShowModal ] = useState(false);
    const history = useHistory()

    const defaultView = {
        // "id": "", 
        // "target": "dataview", 
        // "operationType": "add", 
        // "record_Data": { 
        "dataSetID": '', 
        "dataViewName": "", 
        "script": "", 
        "type": "", 
        "joins": [ 
            // { 
            //     "tableName": "key_indicators", 
            //     "tableAlias": "key", 
            //     "joinField": "code", 
            //     "selectedColumns": "domain,description,indent", 
            //     "joinTable": "bpm_series", 
            //     "joinTableField": "code", 
            //     "filters": [ 
            //         { "report": null, "columnName": "category", "operator": "=", "columnValue": "bpm6", "displayName": null, "isIncluded": false, "id": 0 } 
            //     ], 
            //     "id": 0 
            // } 
        ]
    }

    const defaultJoin = {
        "tableName": "", 
        "tableAlias": "", 
        "selectedColumns": "", 

        "joinField": "",
        "joinTable": "", 
        "joinTableField": "", 

        "filters": [ 
            // { 
            //     "columnName": "", 
            //     "operator": "", 
            //     "columnValue": "",
            //     // "report": null, 
            //     // "displayName": null, 
            //     // "isIncluded": false, 
            //     // "id": 0
            // } 
        ],
    }

    const initialFilter = {
        index: "",
        values: [],
        columns: []
    };

    const defaultFilter = {
        columnName: "",
        operator: "",
        columnValue: ""
    };


    const [ selectedView, setSelectedView ] = useState(defaultView);
    const [ datasets, setDatasets ] = useState([]);
    const { enqueueSnackbar } = useSnackbar();
    const [ processing, setProcessing ] = useState(false);
    const [ viewModel, setViewModel ] = useState(false);
    const [ filterValue, setFilterValue ] = useState(initialFilter);
    const [ responseModal, setResponseModal ] = useState(false);
    const [ responseStatus, setResponseStatus ] = useState(false);
    const [ responseContent, setResponseContent ] = useState("");
    // const [ filterFromValue, setFilterFormValue ] = useState({});

    const init = async () => {
        try {
            setProcessing(true)
            const resp = await getList("datasets");
            if(resp?.responseCode === "00") {
                setDatasets(resp?.listing || [])
            } else {
                enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
        finally {
            setProcessing(false)
        }
    }

    const deleteTable = (key) => {
        setSelectedView({
            ...selectedView,
            joins: [
                ...selectedView.joins?.filter((d, index) => index != key )
            ]
        })
    }

    const deleteFilter = (key, pos) => {
        let obj = selectedView
        obj.joins[pos].filters = obj.joins[pos].filters.filter((next, index) => index != key)
        setFilterValue({
            ...filterValue,
            values: [ ...filterValue.values?.filter((next, index) => index != key) ]
        })
        setSelectedView({ ...obj })
    } 

    const listOperators = [
        { name: "Equal To", value: "=" },
        { name: "Not Equal To", value: "!=" },
        { name: "Contains", value: "like" },
        { name: "Not Contain", value: "not like" },
        { name: "Greater Than", value: ">" },
        { name: "Less Than", value: "<" },
        { name: "Greater Than or Equal To", value: ">=" },
        { name: "Less Than or Equal To", value: "<=" }
    ]

    const handleJoinChange = (name, value, key, isPlanText = false) => {
        let newJoins = [ ...selectedView.joins ];
        let join = newJoins[key];
        let id = "";
        isPlanText ? id = name : id = name.split(`${key}-`)[1];
        join[id] = value;
        newJoins[key] = join;

        setSelectedView({
            ...selectedView,
            joins: newJoins
        })
    };

    const handleFilterJoin = (name, value, key, index) => {
        let nextFilter = [ ...selectedView.joins[index].filters ];
        
        let filter = nextFilter[key];
        let id = name.split(`${key}-`)[1];
        filter[id] = value;
        nextFilter[key] = filter;
        
        let dataViewObject = selectedView
        dataViewObject.joins[index].filters = nextFilter;
        setSelectedView({ ...dataViewObject })
        
    };

    const createOrUpdateDomain = async (values, { resetForm }) => {
        let payload = selectedView;
      
        payload.joins.forEach((next) => {
            delete next.joinTableFields
            delete next.tableFields
        });
        try {
            const resp = await AddorUpdateRecord("dataview", 'add', payload);
            if(resp?.responseCode === "00") {
                init();
                setSelectedView(defaultView);
                setShowModal(false);
                enqueueSnackbar('Action performed successfully');
                history.push('/internal/data-views');
            } else {
                enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
                setResponseStatus(false);
                setResponseContent(String(resp?.message || resp?.responseMessage || 'An error occurred'));
                setResponseModal(true);
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
    }

    const listValues = (args) => {
        if(args)
        return args.map((next) => (next.fieldName))
    };

    const handleMultipleChange = (args, key) => {

        if(args && key){
            let newJoins = [ ...selectedView.joins ]
            let join = newJoins[key]
            join["selectedColumns"] = args.join(",");
            newJoins[key] = join;

            setSelectedView({
                ...selectedView,
                joins:newJoins
            });
        }
        
    };

    const submitFilters = (values) => {
        console.log("Submit");
    }

    const fulls = true;

    useEffect(() => {
        init()
    }, [])

    return (
        <PageContainer pageTitle='Create Dataset Views' processing={processing}>
            <section className="inner-banner parallax-section">
                <div className='overlay'>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <h3 className="wow bounceIn" data-wow-delay="0.9s">Create</h3>
                                <h1 className="wow fadeInUp text-uppercase conference mb-05 mt-05" data-wow-delay="1.6s">Data View</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="services-area section-padding pt-3">
                <div className="container">
                    <div className="row">
                        <div className='col-12 mt-4'>
                            <Formik enableReinitialize initialValues={{ ...selectedView }} onSubmit={createOrUpdateDomain}>
                                {({ isSubmitting, values }) => (
                                    <Form>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} md={6}>
                                                <SelectInput id="dataSetID" required label="Dataset" field="id" fieldDisplay='dataSetName' options={datasets} 
                                                    customChange={(name, value) => {
                                                        const table = datasets?.find(({ id }) => id == value);
                                                        setSelectedView({
                                                            ...selectedView,
                                                            dataSetID: table?.id,
                                                            // joins: [
                                                            //     {
                                                            //         ...defaultJoin,
                                                            //         tableName: table.dB_Table || '',
                                                            //         tableAlias: table?.dataSetName || '',
                                                            //         fields: table?.fields || []
                                                            //     }
                                                            // ]
                                                        })
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <SelectInput id="type" required label="Dataview Type" field="code" fieldDisplay='label' options={[
                                                    { code: 'dbview', label: 'Db View' },
                                                    { code: 'stored_query', label: 'Stored Query' },
                                                ]} 
                                                customChange={(name, value) => {
                                                    setSelectedView({...selectedView, type: value})
                                                }}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextInput id="dataViewName" required label="Data View Name"
                                                    customChange={(name, value) => {
                                                        setSelectedView({ ...selectedView, dataViewName: value })
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextInput id="script" label="Script" multiline minRows={2} placeholder="Enter script (optional)"
                                                    customChange={(name, value) => {
                                                        setSelectedView({ ...selectedView, script: value })
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Divider />
                                                <Button variant="outlined" className='mt-1' onClick={() => {
                                                        setSelectedView({
                                                            ...selectedView, 
                                                            joins: [ ...selectedView.joins, defaultJoin ]
                                                        })
                                                    }} startIcon={<Add />}
                                                >Add Table</Button>
                                            </Grid>

                                            {/* 
                                            
                                                "tableName": "key_indicators", 
                                                "tableAlias": "key", 
                                                "selectedColumns": "domain,description,indent", 

                                                "joinField": "code",
                                                "joinTable": "bpm_series", 
                                                "joinTableField": "code", 

                                                "filters": [ 
                                                    { 
                                                        "columnName": "category", 
                                                        "operator": "=", 
                                                        "columnValue": "bpm6",
                                                        
                                                        "report": null, 
                                                        "displayName": null, 
                                                        "isIncluded": false, 
                                                        "id": 0
                                                    } 
                                                ], 
                                            
                                            */}
                                            <Grid item xs={12} container spacing={3}>
                                                {
                                                    values.joins?.map((table, key) => (
                                                        <Grid key={key} container alignItems={'center'} item xs={12} spacing={2}>
                                                            <Grid item lg={12} xs={12}>
                                                                {
                                                                    key > 0 &&
                                                                    <IconButton color="error" size={'large'} title="Delete"
                                                                        onClick={() => deleteTable(key)}
                                                                    >
                                                                        <Delete />
                                                                    </IconButton>
                                                                }
                                                            </Grid>
                                                            <Grid item xs={12} lg={3} md={4}>
                                                                <SelectInput capitalizeLabel={false} value={table.tableName
                                                                } options={datasets} field="id" fieldDisplay='dB_Table' id={`${key}-tableName`} label="Table Name" floatingLabel
                                                                    customChange={(name, value) => {
                                                                        const tab = datasets?.find(({ id }) => String(id) == String(value));
                                                                        handleJoinChange(name, tab.dB_Table, key);
                                                                        if(tab)
                                                                        handleJoinChange("tableFields", tab.fields, key, true);
                                                                    }}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} lg={3} md={4}>
                                                                <MultipleSelectChip customValue={table?.selectedColumns.length > 0 ? table?.selectedColumns.split(',') : []} entries={listValues(table?.tableFields) || []} label="Selected Columns" id={`${key}-selectedColumns`} 
                                                                customChange={(name, value) => {
                                                                    handleJoinChange(name, value.join(","), key)
                                                                }}
                                                                />   
                                                            </Grid>
                                                            <Grid item xs={12} lg={3} md={4}>
                                                                <SelectInput capitalizeLabel={false} value={table.joinField
                                                                } options={table?.tableFields} field="id" fieldDisplay='fieldName' id={`${key}-joinField`} label="Join Field" floatingLabel
                                                                    customChange={(name, value) => {
                                                                        const tab = table?.tableFields.find(({ id }) => String(id) == String(value));
                                                                        if(tab)
                                                                        handleJoinChange(name, tab.fieldName, key);
                                                                    }}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} lg={3} md={4}>
                                                                <SelectInput options={datasets}  capitalizeLabel={false} value={table.joinTable} field="id" fieldDisplay='dB_Table' id={`${key}-joinTable`} label="Table Join" floatingLabel
                                                                    customChange={(name, value) => {
                                                                        const tab = datasets?.find(({ id }) => String(id )== String(value));
                                                                        handleJoinChange(name, tab.dB_Table, key)
                                                                        handleJoinChange("joinTableFields", tab.fields, key, true);
                                                                    }}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} lg={2.5} md={4}>
                                                                <SelectInput options={table?.joinTableFields || []} field="id" value={table.joinTableField} fieldDisplay='fieldName' id={`${key}-joinTableField`} label="Table Join Column" floatingLabel
                                                                    customChange={(name, value) => {
                                                                        const tab = table?.joinTableFields.find(({ id }) => String(id) == String(value));
                                                                        handleJoinChange(name, tab.fieldName,  key)
                                                                    }}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} lg={2.5} md={4}>
                                                                <Button className='mt-1' variant='contained' startIcon={<TuneIcon />}
                                                                    onClick={() => {
                                                                        table?.filters.length == 0 
                                                                        ?
                                                                        setFilterValue({ index: key, values: [ defaultFilter ], columns: listValues(table?.tableFields) || [] })
                                                                        :
                                                                        setFilterValue({ index: key, values: table?.filters, columns: listValues(table?.tableFields) })
                                                                        
                                                                        if(selectedView.joins[key].filters.length == 0){
                                                                            let newFilter = selectedView
                                                                            newFilter.joins[key].filters.push(defaultFilter)
                                                                            setSelectedView({
                                                                                ...newFilter
                                                                            });
                                                                        }
                                                                        
                                                                        setViewModel(true);
                                                                    }}
                                                                >Filters</Button>
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <Divider />
                                                            </Grid>
                                                        </Grid>
                                                    ))
                                                }
                                            </Grid>
                                            <Grid item xs={12} container justifyContent={'center'} alignItems='center'>
                                                
                                                <Button className='mr-05' disabled={isSubmitting} onClick={() => { if(!isSubmitting) { setShowModal(false); setSelectedView(defaultView) }}} color="secondary" variant="contained" >Cancel</Button>
                                                
                                                <Button type='submit' variant="contained" disabled={isSubmitting} className="ml-05">
                                                    {
                                                        isSubmitting ?
                                                        <CircularProgress size={15} color="inherit" />
                                                        :
                                                        values?.domainID ? 'Update Dataset View' : 'Add Dataset View'
                                                    }
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
                <Dialog open={viewModel} fullWidth={fulls} maxWidth="md">
                    <DialogTitle><h3>Filters</h3></DialogTitle>
                        <Formik
                            enableReinitialize
                            initialValues={{...filterValue}}
                            onSubmit={submitFilters}
                        >
                            {({ isSubmitting, values }) => (
                                <Form>
                                    <DialogContent>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} md={12} lg={12}>
                                                <Button variant='outlined' className='mb-1' startIcon={<Add />}
                                                    onClick={() => {
                                                        setFilterValue({ ...filterValue, values: [...filterValue.values, defaultFilter ] })
                                                        let newFilter = selectedView
                                                        newFilter.joins[filterValue.index].filters.push(defaultFilter)
                                                        setSelectedView({
                                                            ...newFilter
                                                        });
                                                    }}
                                                >Add Filter</Button>
                                            </Grid>
                                            {
                                                values.values?.map((next, key) => (
                                                    <Grid key={key} container alignItems={'center'} item xs={12} spacing={2}>
                                                        <Grid item lg={12} xs={12}>
                                                            {
                                                                key > 0 &&
                                                                <IconButton color="error" size={'large'} title="Delete"
                                                                    onClick={() => deleteFilter(key, filterValue.index)}
                                                                >
                                                                    <Delete />
                                                                </IconButton>
                                                            }
                                                        </Grid>
                                                        <Grid item xs={12} md={6} lg={4}>
                                                            <SelectInput 
                                                                value={next?.columnName?.length > 0 ? next?.columnName : ""}  
                                                                options={filterValue?.columns?.map((next) => ({ name: next })) || []} 
                                                                label="Columns Names" 
                                                                id={`${key}-columnName`}
                                                                customChange={(name, value) => {
                                                                    handleFilterJoin(name, value, key, filterValue.index)
                                                                }}
                                                                field="name"
                                                                fieldDisplay='name'
                                                                floatingLabel
                                                            />
                                                           
                                                        </Grid>
                                                        <Grid item xs={12} md={6} lg={4}>
                                                            <SelectInput value={next?.operator?.length > 0 ? listOperators.find(({ value }) => value == next?.operator)?.name : ''} options={listOperators} field="value" fieldDisplay='name' id={`${key}-operator`} label="Operators" floatingLabel
                                                                customChange={(name, value) => {
                                                                    handleFilterJoin(name, value, key, filterValue.index)
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6} lg={4}>
                                                            <TextInput floatingLabel label="Value" id={`${key}-columnValue`} value={next.columnValue}
                                                                customChange={(name, value) => {
                                                                    handleFilterJoin(name, value, key, filterValue.index)
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Divider />
                                                        </Grid>
                                                    </Grid>
                                                ))
                                            }
                                        </Grid>
                                    </DialogContent>
                                    <DialogActions className='pr-3 pb-3'>
                                        <Button type="submit" variant='contained' onClick={() => setViewModel(false)} >Submit</Button>
                                        <Button variant='contained' type='button' color='error' onClick={() => { setViewModel(false)}}>Cancel</Button>
                                    </DialogActions>
                                </Form>
                            )}
                        </Formik>
                    
                    {/* Dialog Box for request responses */}
                    <DialogBox isIconTitle content={responseContent} responseType={responseStatus} opener={responseModal} closer={setResponseModal} />
                </Dialog>
            </div>
        </PageContainer>
    )
}

export default CreateDataView